export const SURF_CUSTOMERS = ["c9b5e717-0b11-e511-80d0-005056956c1a", "3902a8cf-776f-e611-80e0-005056956c1a"];
export const SURF_ROLES = ["automation-admins", "automation-developers", "ten", "noc-engineers", "SuperuserRO"];

type Ruleset = {
  view: string[];
  edit: string[];
};

type RulesetContainer = {
  [key: string]: Ruleset;
};

const infraRules: RulesetContainer = {};
for (const productType of ["Port", "IP", "IP_PREFIX", "L2VPN", "L3VPN", "LightPath", "FW"]) {
  infraRules[productType] = {
    view: [
      "Infrabeheerder",
      "Infraverantwoordelijke",
      "Beveiligingsverantwoordelijke",
      "surfcert-kernel",
      "SuperuserRO",
      "noc-fls",
      "noc-engineers",
    ],
    edit: ["Infraverantwoordelijke", "Beveiligingsverantwoordelijke", "surfcert-kernel"],
  };
}
export const AccessRules: RulesetContainer = {
  ...infraRules,
  Wireless: {
    view: ["SURFwireless-beheerder", "SURFwireless-verantwoordelijke", "SuperuserRO", "noc-fls", "noc-engineers"],
    edit: [],
  },
  cert: {
    view: [
      "Infrabeheerder",
      "Infraverantwoordelijke",
      "Beveiligingsverantwoordelijke",
      "surfcert-kernel",
      "SuperuserRO",
      "noc-fls",
      "noc-engineers",
      "surfdomeinen_admins",
    ],
    edit: ["Infraverantwoordelijke", "Beveiligingsverantwoordelijke", "surfcert-kernel"],
  },
  domains: {
    view: ["DNS-Beheerder", "Domeinnamenverantwoordelijke", "surfdomeinen_admins", ...SURF_ROLES],
    edit: ["DNS-Beheerder", "Domeinnamenverantwoordelijke", "surfdomeinen_admins", "SuperuserRO"],
  },
  support: {
    view: [],
    edit: [],
  },
  maintenance: {
    view: ["Infrabeheerder", "Infraverantwoordelijke", "SuperuserRO", "noc-fls", "noc-engineers"],
    edit: ["Infraverantwoordelijke"],
  },
  notification_settings: {
    view: ["Infrabeheerder", "Infraverantwoordelijke", "SuperuserRO"],
    edit: ["Infraverantwoordelijke"],
  },
};

export interface RoleCheckResult {
  ok: boolean;
  event: "requirements-not-met" | "no-roles" | "requirements-met" | "no-organization";
  need: string[];
  productType?: string;
  requestedAction?: "view" | "edit";
}

export const SuperUserRoles = ["SuperuserRO", "noc-fls", "noc-engineers", "surfcert-kernel", "automation-developers"];

export const rulesAreAvailable = (productType: string): boolean => productType in AccessRules;
export const rolesWithEditAccess = (): string[] => [
  ...new Set(Object.keys(AccessRules).flatMap((productType) => AccessRules[productType].edit)),
];
